import { useState, useEffect } from 'react';
import './App.css';
import Navbar from './components/Navbar';
import Home from './components/pages/Home';
import About from './components/pages/About';
import FocusAreas from './components/pages/FocusAreas';
import Programs from './components/pages/Programs';
import WhyChooseUs from './components/pages/WhyChooseUs.jsx';
import Impact from './components/pages/Impact.jsx';
import Contact from './components/pages/Contact.jsx';
import Footer from './components/Footer.jsx';

// Standalone pages
import AboutPage from './components/pages/AboutPage.jsx';
import ProgramsPage from './components/pages/ProgramsPage.jsx';
import ImpactPage from './components/pages/ImpactPage.jsx';
import ContactPage from './components/pages/ContactPage.jsx';

function App() {
  const [route, setRoute] = useState('#home');

  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash || '#home';
      
      // Standalone pages routes
      if (['#about', '#programs', '#impact', '#contact'].includes(hash)) {
        setRoute(hash);
        window.scrollTo({ top: 0, behavior: 'instant' });
      } else {
        setRoute('#home');
        // If it's a home-page sub-section anchor (like #why-choose-us, #objectives)
        if (hash !== '#home') {
          setTimeout(() => {
            const id = hash.replace('#', '');
            const element = document.getElementById(id);
            if (element) {
              element.scrollIntoView({ behavior: 'smooth' });
            }
          }, 100);
        }
      }
    };

    window.addEventListener('hashchange', handleHashChange);
    handleHashChange(); // Run initial check on mount

    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);

  return (
    <div className="min-h-screen bg-[#FBF9F3] text-[#0A355C] selection:bg-[#E0A526] selection:text-[#0A355C] antialiased">
      <Navbar />
      <main>
        {route === '#about' && <AboutPage />}
        {route === '#programs' && <ProgramsPage />}
        {route === '#impact' && <ImpactPage />}
        {route === '#contact' && <ContactPage />}
        {route === '#home' && (
          <>
            <Home />
            <About />
            <FocusAreas />
            <Programs />
            <WhyChooseUs />
            <Impact />
            <Contact />
          </>
        )}
      </main>
      <Footer />
    </div>
  );
}

export default App;
